import React from "react";
import { Box } from "@mui/system";
import DetailList from "./DetailList"
import SectionHeader from "./SectionHeader";

const Section = (props) => {
    const { title, listItems, numbered, spacing} = props
    
    return (
        <Box>
            <SectionHeader title={title} component="h2" />
            <DetailList listItems={listItems} numbered={numbered} spacing={spacing} />
        </Box>
    )
}

export default Section;